import { render } from "./Afgerond.vue?vue&type=template&id=b527d996"
import script from "./Afgerond.vue?vue&type=script&lang=js"
export * from "./Afgerond.vue?vue&type=script&lang=js"

import "./Afgerond.vue?vue&type=style&index=0&id=b527d996&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__